import { render, staticRenderFns } from "./CourseStudy.vue?vue&type=template&id=42c8f88e&scoped=true&"
import script from "./CourseStudy.vue?vue&type=script&lang=js&"
export * from "./CourseStudy.vue?vue&type=script&lang=js&"
import style0 from "./CourseStudy.vue?vue&type=style&index=0&id=42c8f88e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c8f88e",
  null
  
)

export default component.exports